import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { MenuItem, ListItemIcon, Tooltip } from '@material-ui/core'
import { moveToPage } from 'actions/customForm/addOrEdit'
import { ArrowBack } from '@material-ui/icons'

const MoveToPageMenuOptions = ({
	pagebreaks,
	pageSelected,
	moveToPage,
	handleClose,
	selectMenu,
	index,
}) => {
	// const pages = [...new Array(200)].map((el, idx) => idx)

	return (
		<>
			<MenuItem onClick={() => selectMenu('default')}>
				<ListItemIcon>
					<ArrowBack />
				</ListItemIcon>
			</MenuItem>
			{[{ idx: 0 }, ...pagebreaks].map((pagebreak, idx) => {
				const menuItem = (
					<MenuItem
						key={`moveToPageMenuItem${idx}menuItem`}
						onClick={() => {
							moveToPage({
								index,
								page: idx,
								pagebreak,
								direction: pageSelected < idx ? 'forward' : 'backward',
							})
							handleClose()
							selectMenu('default')
						}}
						disabled={pageSelected === idx}
					>
						Move to page {idx + 1}
					</MenuItem>
				)

				return pageSelected === idx ? (
					<Tooltip
						key={`moveToPageMenuItem${idx}tooltip`}
						title="Section is already on this page"
					>
						<div>{menuItem}</div>
					</Tooltip>
				) : (
					menuItem
				)
			})}
		</>
	)
}

export default connect(
	(state) => ({
		pagebreaks: state.customForm.addOrEdit.form.sections
			.map((id, idx) => ({
				...state.customForm.addOrEdit.sectionsByID[id],
				idx,
			}))
			.filter((el) => el?.type === 'pagebreak'),
		pageSelected: state.customForm.addOrEdit.pageSelected,
	}),
	(dispatch) => bindActionCreators({ moveToPage }, dispatch),
)(MoveToPageMenuOptions)
